import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import CreateRoundedIcon from '@material-ui/icons/CreateRounded';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';

import {
  ContentEmailSpecFragment,
  ContentEmailSpecListInput,
  GenericStatus,
  useModifyContentEmailMutation,
} from 'api';
import notify from 'notify';
import { generateLink } from 'Links';

import { useModifyContentEmails } from '../../updaters';

interface Props {
  contentEmail: ContentEmailSpecFragment;
  filter?: ContentEmailSpecListInput;
}

const Actions: FC<Props> = ({ contentEmail, filter }) => {
  const { t } = useTranslation();

  const mutationOptions = useModifyContentEmails({ data: filter });
  const { mutate: modifyEmailMutation } = useModifyContentEmailMutation({
    ...mutationOptions,
    onSuccess: () => notify.info({ message: t('components:savedSuccessfully') }),
  });

  function handleDisableSwitch() {
    modifyEmailMutation({ data: { id: contentEmail.id, config_status: GenericStatus.Disabled } });
  }

  function handleEnableSwitch() {
    modifyEmailMutation({ data: { id: contentEmail.id, config_status: GenericStatus.Active } });
  }

  function renderToggleSwitch() {
    if (contentEmail.config_status === GenericStatus.Active) {
      return (
        <Grid item>
          <Tooltip title={t('common:enabled')}>
            <IconButton onClick={handleDisableSwitch}>
              <ToggleOnIcon color="primary" />
            </IconButton>
          </Tooltip>
        </Grid>
      );
    }

    return (
      <Grid item>
        <Tooltip title={t('common:disabled')}>
          <IconButton onClick={handleEnableSwitch}>
            <ToggleOffIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    );
  }

  function renderEditIcon() {
    return (
      <Grid item>
        <Tooltip title={t('common:edit')}>
          <IconButton component={generateLink(`/admin/emails/${contentEmail.id}`)}>
            <CreateRoundedIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    );
  }

  return (
    <Grid container alignItems="center" justify="center">
      {renderEditIcon()}
      {renderToggleSwitch()}
    </Grid>
  );
};

export default Actions;
